export default {
  title: 'البروتوكول',
  subtitle: 'معلومات البروتوكول',
  assign: 'تعيين إلى خدمة',
  creationDate: 'تم الإنشاء في '
}
